import React from "react";

import { Chip, ChipPropsColorOverrides, Tooltip } from "@mui/material";
import { OverridableStringUnion } from "@mui/types";

import { JobStatus as JobStatusEnum } from "../../services/utils/status";

type StatusDetails = {
  description: string;
  color: OverridableStringUnion<
    "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning",
    ChipPropsColorOverrides
  >;
};

const STATUSES: { [key in JobStatusEnum]: StatusDetails } = {
  [JobStatusEnum.SUBMITTED]: { description: "Asset Submitted to ATP for Transcoding", color: "default" },
  [JobStatusEnum.PROGRESSING]: { description: "Transcoding in Progress", color: "default" },
  [JobStatusEnum.COMPLETE]: { description: "Transcoding Completed Successfully", color: "info" },
  [JobStatusEnum.REGISTERED]: { description: "Successfully Registered with Stitcher", color: "info" },
  [JobStatusEnum.ERROR]: { description: "Transcoding Failed", color: "error" },
  [JobStatusEnum.BLOCKED]: { description: "Rejected due to duplication checks", color: "error" },
  [JobStatusEnum.FAILED]: { description: "Stitcher Registration Failed", color: "warning" },
  [JobStatusEnum.UNSUCCESSFUL]: { description: "Ad Server Response Failed", color: "warning" },
  [JobStatusEnum.SUCCESS]: { description: "Job Completed Successfully", color: "success" },
  [JobStatusEnum.INACTIVE]: { description: "Deactivated", color: "dark" },
};

type JobStatusProps = {
  status: JobStatusEnum;
  size?: "medium" | "small";
  variant?: "outlined" | "filled";
};

const JobStatus: React.FC<JobStatusProps> = ({ status, size = "small", variant = "filled" }) => {
  const statusDetails = STATUSES[status];
  return (
    <Tooltip title={statusDetails?.description}>
      <Chip
        size={size}
        variant={variant}
        label={status}
        sx={{ lineHeight: "normal", minWidth: "110px", fontWeight: "bold" }}
        color={statusDetails?.color}
      />
    </Tooltip>
  );
};

export default JobStatus;
